@let pageData = gridData();
<app-spinner [loading]="spinning()"></app-spinner>
<section class="main-table">
  <div class="main-table__header">
    <h1 class="main-table__title">{{labels.title}}</h1>
    @if(this.isEditor()) {
      <button mat-button class="button main-table__button" (click)="onCreate()">{{labels.createButton}}</button>
    }
  </div>
  <app-total class="main-table__total" [value]="total()"></app-total>
  @if (pageData) {
    <app-table class="main-table__table" [columnDefs]="columnDefs()" [rowData]="pageData.rowData" [gridOptions]="{}"
      (dataRequest)="onDataRequest($event)" [paginationState]="pageData.paginationState" (filtersChanged)="onFilterChanged($event)" (sortChanged)="onSortChanged($event)" [filter]="pageData.filter" [sort]="pageData.sort"></app-table>
  }
</section>
